import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { action } from 'satcheljs';

export const initializeOwaDateTimeStore = action(
    'initializeOwaDateTimeStore',
    (
        options: Pick<
            UserOptionsType,
            'DateFormat' | 'TimeFormat' | 'TimeZone' | 'MailboxTimeZoneOffset'
        >,
        shouldInitializeTimeZoneAnonymously?: boolean
    ) => ({
        ...options,
        shouldInitializeTimeZoneAnonymously: shouldInitializeTimeZoneAnonymously,
    })
);

export const setDateFormat = action('setDateFormat', (dateFormat: string) => ({ dateFormat }));
export const setTimeFormat = action('setTimeFormat', (timeFormat: string) => ({ timeFormat }));
export const setLocalTimeZone = action('setLocalTimeZone', (timeZone: string) => ({ timeZone }));
